import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import classNames from "classnames";
import { useStyles } from "./styles";
const QuestionSkeletonLoaderComponents = ({ count = 5 }) => {
  const classes = useStyles();
  return (
    <div
      className={classNames(
        classes.timeline,
        "timelineCommon position-relative mt-4"
      )}
    >
      {[...Array(count)].map((_, i) => (
        <>
          <div className="timel__items position-relative" key={i}>
            <div className="timel__num position-absolute bg-light rounded-pill fw-semibold d-flex align-items-center justify-content-center">
              <Skeleton width="60%" />
            </div>
            <div className="timel__content">
              <div className="timel__head fw-bold text-dark mb-2">
                {/* 5 = checkboxText (questiontype) */}
                <Skeleton width="60%" />
              </div>
              <div className="timel__body">
                <div className="qtype__one">
                  <p>
                    <Skeleton count={2} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default QuestionSkeletonLoaderComponents;
